/**
 * The canonical language registry — single source of truth for which base
 * languages and regional variants the app supports. i18n resource
 * registration, the Redux localization state, and every language picker
 * derive from these lists; never duplicate them.
 */
export const SUPPORTED_LANGUAGES: readonly string[] = ["en", "de", "uk", "pl", "ja", "ar"];

export const SUPPORTED_VARIANTS: readonly string[] = [
  "en-US",
  "en-GB",
  "de-DE",
  "de-AT",
  "uk",
  "pl",
  "ja-JP",
  "ar",
];

/**
 * The supported base languages by native name — readable regardless of the
 * current UI language. Backend-rendered emails speak these languages too.
 */
export const LANGUAGE_OPTIONS: Array<{ code: string; label: string }> = [
  { code: "en", label: "English" },
  { code: "de", label: "Deutsch" },
  { code: "uk", label: "Українська" },
  { code: "pl", label: "Polski" },
  { code: "ja", label: "日本語" },
  { code: "ar", label: "العربية" },
];
